import React from 'react';
import MainRoutes from 'core/components/route/MainRoutes';
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient();

const App: React.FC = () => {
  
  return (
    <div>
      <QueryClientProvider client={queryClient}>
      <MainRoutes />
      </QueryClientProvider>
    </div>
  );
};

export default App;
